import { listTimeClocks, TimeClock } from 'api/admin/timeClock/listTimeClocks'

export async function listAllTimeClocksForCompany(
  companyId: number
): Promise<TimeClock[]> {
  const items: TimeClock[] = []
  let cursor: string | undefined

  do {
    const page = await listTimeClocks({
      companyId,
      cursor,
    })
    items.push(...page.items)
    cursor = page.nextCursor ?? undefined
  } while (cursor)

  return items
}
